import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { User } from './user.model';

export interface UserState extends EntityState<User> {}

@Injectable()
@StoreConfig({
  name: 'user',
})
export class UserStore extends EntityStore<UserState> {
  constructor() {
    super();
  }
}
